module.exports = __webpack_public_path__ + "static/media/header_image_03.bd045994.jpg";